import {
  compose,
  graphql,
} from 'react-apollo'
import { getOffersQuery } from '../queries'
import { deleteOfferMutation } from '../mutations'
import AdminOfferListItem from '../components/adminOfferListItem'

export default compose(
  graphql(getOffersQuery),
  graphql(deleteOfferMutation, {
    name: 'deleteOfferMutation',
    options: {
      refetchQueries: [{
        query: getOffersQuery,
      }],
    },
  }),
)(AdminOfferListItem)



// WEBPACK FOOTER //
// ./src/modules/admin/containers/adminOfferListItem.js